import type { SelectOption } from '@repo/ui';

interface StatusOption extends SelectOption {
  color: string;
}

// AR Exception Report status options with user-friendly labels and colors
export const AR_STATUS_OPTIONS: StatusOption[] = [
  {
    value: 'OK',
    label: 'No Issues',
    color: '#10B981', // green
  },
  {
    value: 'VARIANCE_NON_ZERO',
    label: 'Variance Detected',
    color: '#F59E0B', // amber
  },
  {
    value: 'MISSING_IN_QBO',
    label: 'Missing in QBO',
    color: '#EF4444', // red
  },
  {
    value: 'MISSING_IN_CLIO',
    label: 'Missing in Clio',
    color: '#EF4444', // red
  },
  {
    value: 'DUPLICATE',
    label: 'Duplicate',
    color: '#8B5CF6', // purple
  },
  {
    value: 'LOW_CONFIDENCE_MATCH',
    label: 'Low Confidence Match',
    color: '#6B7280', // gray
  },
];

// Trust Reconciliation Report status options with user-friendly labels and colors
export const TRUST_STATUS_OPTIONS: StatusOption[] = [
  {
    value: 'OK',
    label: 'No Issues',
    color: '#10B981', // green
  },
  {
    value: 'MISSING_IN_QBO_BANK',
    label: 'Missing in QBO Bank',
    color: '#F59E0B', // amber
  },
  {
    value: 'MISSING_IN_QBO_LIABILITY',
    label: 'Missing in QBO Liability',
    color: '#F59E0B', // amber
  },
  {
    value: 'MISSING_IN_BOTH_QBO',
    label: 'Missing in Both QBO',
    color: '#EF4444', // red
  },
  {
    value: 'MISSING_IN_CLIO',
    label: 'Missing in Clio',
    color: '#8B5CF6', // purple
  },
];

